import React, { useState } from "react";
import CustomDropdown from "../components/CustomDropdown";
import { MDBIcon } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";
import { handleComponent } from "../helpers/Forms";
import DefaultMenuScreen from "../components/DefaultMenuScreen";


const Auxiliar = () => {
  
  const navigate = useNavigate();
  const [selectItem, setSelectItem] = useState(null);

  const handleSelectItem = (dropdownName, selectItem, indexItem) => {
    setSelectItem({ dropdownName, selectItem, indexItem });
  };
  const handleExit = () => {
    navigate("/");
  };

  

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="bg-light  col-auto col-md-3 min-vh-100 ">
            <a className="text-decoration-none d-flex align-itemcenter">
              <span className="ms-1 fd-4 mt-4 p-3">
                <h2 className="title-text">Auxiliar</h2>
              </span>
            </a>
            <ul className=" nav nav-underline flex-column m-3">
              <CustomDropdown
                title="Cotizador"
                items={["Nuevo", "Asignaciones"]}
                iconMDB="hand-holding-usd"
                onSelectOpt={handleSelectItem}

              />

              <li className="nav-item align-items-end justify-content-end">
                <button
                  href=""
                  className="nav-link active w-100 text-start fs-5"
                  onClick={handleExit}
                >
                  <MDBIcon fas icon="sign-out-alt" className="m-2" />
                  <span>Salir</span>
                </button>
              </li>
            </ul>
          </div>
          <div className="col-auto col-md-9 min-vh-100 mt-4">
            {selectItem ? (
              <div className="m-5">
                <h3>{selectItem.dropdownName}</h3>
                {handleComponent(selectItem.dropdownName, selectItem.indexItem)}
                {/* Aqui se despliega componente de formularios de cada opcion */}
              </div>
            ) : (
              <DefaultMenuScreen />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Auxiliar;
